import React, { useState, useEffect } from "react"

import Input from "components/shared/Inputs/Inputs"
import Button from "components/shared/Button/Button"
import Select from "react-select"

import api from "../../services/api"
import Swal from "sweetalert2"
import { useNavigate } from "react-router-dom"
import AuthService from "../../services/Auth.service"

const HidrometroCadastro = () => {
  let navigate = useNavigate()
  const initialState = {
    number: "",
    desc: "",
    model: "",
    pulse: "",
  }

  const Empresa = {
    OID_EMPRESA: "",
    NM_RAZAO_SOCIAL: "",
  }

  const user = AuthService.getCurrentUser()

  let checkempresa = null
  let DS_STATUS = null
  if (user != null) {
    DS_STATUS = user.user.DS_STATUS
    if (user.empresa[0] != undefined) {
      checkempresa = user.empresa[0].OID_EMPRESA
    }
  }

  let stateempresa = null
  let [makers, setMakers] = useState([])
  const [condos, setCondo] = useState([])
  let [lc, setLc] = useState(Empresa)
  const [imovelid, setImo] = useState(initialState)
  const [search, setSearch] = useState(initialState)
  const [selectedCond, setSelectedCond] = useState(null)
  const [selectedImovel, setSelectedImovel] = useState(null)

  const fetchCondo = () => {
    let condo = []
    api.get("/empresa/").then(response => {
      response.data.map(elem => {
        condo.push({
          value: elem.OID_EMPRESA,
          label: elem.NM_RAZAO_SOCIAL,
        })
      })
      setCondo(condo)
    })
  }

  if (DS_STATUS == 10) {
    useEffect(() => {
      fetchCondo()
    }, [])
  }

  const onChangeHandlerCond = selectedOption => {
    if (selectedOption === null) {
      setSelectedCond(null)
      setSelectedImovel(null)
      checkempresa = null
    } else {
      setSelectedCond(selectedOption)
      checkempresa = selectedOption.value
      fetchimoCondo()
    }
  }

  const fetchimoCondo = () => {
    let maker = []
    api.get("/imovel/vagos/" + checkempresa).then(response => {
      response.data.map(elem => {
        maker.push({
          value: elem.OID_IMOVEL,
          label: elem.imovel,
        })
      })
      setMakers(maker)
    })
  }

  useEffect(() => {
    fetchimoCondo()
  }, [])

  const onChangeHandlerImovel = selectedOption => {
    setSelectedImovel(selectedOption)
    if (selectedOption) {
      setImo({ ...imovelid, maker: selectedOption.value })
    }
  }

  const [register, setRegister] = useState(initialState)

  const onChangeHandler = prop => event => {
    setRegister({ ...register, [prop]: event.target.value })
  }

  const submitHandler = event => {
    event.preventDefault()

    if (checkempresa == null) {
      checkempresa = selectedCond ? selectedCond.value : null
    }

    if (!selectedImovel) {
      Swal.fire({
        icon: "warning",
        text: "Selecione um Imóvel para cadastrar o Medidor",
      })
      return
    }

    if (register.number < 1) {
      Swal.fire({
        icon: "warning",
        text: "favor entrar com o Número do Hidrometro",
      })
      return
    }

    if (
      !register.pulse ||
      register.pulse.trim() === "0" ||
      register.pulse.trim() === ""
    ) {
      Swal.fire({
        icon: "warning",
        text: "favor entrar com o Pulso/Litro",
      }).then(() => {
        // Foca no input após o alerta ser fechado
        setTimeout(() => {
          const inputElement = document.getElementById("pulse-input")
          if (inputElement) {
            inputElement.focus()
            inputElement.select()
          }
        }, 300)
      })
      return
    }

    let imovel = {
      OID_CONDOMINIOATUAL: checkempresa,
    }

    const body = {
      NR_HIDROMETRO: register.number,
      DS_DESCRICAO_HIDROMETRO: register.desc,
      DS_MODELO_HIDROMETRO: register.model,
      NR_CONSUMO_LITROS: register.pulse,
      TP_ATIVO: "N",
    }

    let hidro = {
      OID_IMOVEL: imovelid.maker,
      NR_MEDIDOR: body.NR_HIDROMETRO,
      DS_DESCRICAO_MEDIDOR: body.DS_DESCRICAO_HIDROMETRO,
      DS_MODELO_MEDIDOR: body.DS_MODELO_HIDROMETRO,
      NR_CONSUMO_LITROS: body.NR_CONSUMO_LITROS,
      TP_ATIVO: "S",
    }
    console.log(hidro)

    api
      .post("/hydrometers", hidro)
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Medidor Cadastrado",
        })
      })
      .catch(error => {
        const apiData = error.response && error.response.data
        if (
          apiData &&
          (apiData.error === "NR_MEDIDOR already exists" ||
            apiData.message === "NR_MEDIDOR already exists")
        ) {
          Swal.fire({
            icon: "warning",
            text: "NR medidor já cadastrado",
          })
        } else {
          // Handle other errors or log them
          Swal.fire({
            icon: "error",
            text: "Esse Imóvel já possui um medidor.",
          })
          console.log(error)
        }
      })

    // api.post("/hydrometers", hidro).then(() => {
    //   Swal.fire({
    //     icon: "success",
    //     title: "Medidor Cadastrado"
    //   })
    // }).catch((error) => {
    //   Swal.fire({
    //     icon: "warning",
    //     text: "Esse Imóvel já possui um medidor."
    //   })
    //   console.log(error);
    // })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <label id="component-title">Cadastrar | Medidor</label>

        <ol className="breadcrumb m-0">
          <li className="breadcrumb-item active">
            Preencha os dados para cadastrar um medidor ao Imóvel selecionado
          </li>
        </ol>

        <div>
          <Button
            icon="bx bx-left-arrow-circle"
            iconPosition="left"
            primaryColor="#f8f7ff"
            hoverColor="#f8f7ff"
            text="Voltar"
            link="/cadastro/hidrometro"
            styles={{
              marginLeft: "1.5rem",
              background: "#f8f7ff",
              color: "blue",
            }}
          />
        </div>
        <form className="component-form container" style={{ margin: "0px" }}>
          <div className="container">
            {DS_STATUS == 10 ? (
              <div className="row">
                <div className="col-6">
                  <label htmlFor="Condominio" className="mt-1">
                    Condomínio
                  </label>
                  <Select
                    id="inlineFormSelectPrefc"
                    placeholder="Selecione..."
                    onChange={onChangeHandlerCond}
                    styles={{
                      container: provided => ({
                        ...provided,
                        minWidth: "245px",
                      }),
                      menu: provided => ({
                        ...provided,
                        backgroundColor: "white",
                        color: "black",
                      }),
                    }}
                    options={condos}
                    value={selectedCond}
                    isClearable
                  />
                </div>
              </div>
            ) : null}

            <div className="row">
              <div className="col-6">
                <label htmlFor="Imovel" className="mt-1">
                  Imóvel *
                </label>
                <Select
                  id="inlineFormSelectPref"
                  placeholder="Selecione..."
                  onChange={onChangeHandlerImovel}
                  styles={{
                    container: provided => ({
                      ...provided,
                      minWidth: "245px",
                    }),
                    menu: provided => ({
                      ...provided,
                      backgroundColor: "white",
                      color: "black",
                    }),
                  }}
                  options={makers}
                  value={selectedImovel}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Input
                  id="number"
                  label="Número Medidor"
                  value={register.number}
                  onChange={onChangeHandler("number")}
                  styles={{ width: "100%" }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Input
                  id="desc"
                  label="Descrição"
                  value={register.desc}
                  onChange={onChangeHandler("desc")}
                  styles={{ width: "100%" }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Input
                  id="model"
                  label="Modelo"
                  value={register.model}
                  onChange={onChangeHandler("model")}
                  styles={{ width: "100%" }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Input
                  id="pulse-input"
                  label="Pulso/Litro"
                  value={register.pulse}
                  onChange={onChangeHandler("pulse")}
                  styles={{ width: "100%" }}
                />
              </div>
            </div>
            <div className="row">
              <div style={{ textAlign: "center", marginTop: "1.5rem" }}>
                <Button
                  icon="ti-agenda"
                  text="Cadastrar"
                  action={submitHandler}
                  primaryColor="#5d4ec0"
                  hoverColor="#4eadc0"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </React.Fragment>
  )
}

export default HidrometroCadastro
